// extracted by mini-css-extract-plugin
export default {"tableRow":"task_tableRow__tOKTi","tableCell":"task_tableCell__ZOgyb","grayRow":"task_grayRow__Bo+3v"};